/**
 * ProductRegisterPresenter
 * --
 */
import { useState } from 'react';
import { Content, Title, Row, Col, ModalLayout } from 'components';

import {
  SalesInformation,
  ProductImageInformation,
  ProductDeliveryInformation,
  ProductPromotionInformation,
  ProductHashtagInformation,
  ProductDetailInformation2 as ProductDetailInformation,
  ProductOptionInformation,
  ProductPaymentAdditionalInformation,
  ProductLoadModal,
} from './components';
import styles from './styles';
import { Button, Flex } from 'antd';
import { useProductState } from './context';
import { useProductImageState } from './context/ProductImageProvider';
import { useProductOptionState } from './context/ProductOptionProvider';
import { useProductDetailInformationState } from './context/ProductDetailInformationProvider';
import { useProductDeliveryState } from './context/ProductDeliveryProvider';
import { useProductTagState } from './context/ProductTagProvider';
import { useProductPaymentAdditionalInformationState } from './context/ProductPaymentAdditionalInformationProvider';
import { DiffOutlined } from '@ant-design/icons';

/**----------------------------------------
 * [Component] 총관리자: 상품등록 - 프레젠터
 * ----------------------------------------
 */
const ProductRegisterPresenter = ({ defaultData, onDefaultData, onSubmit }) => {
  const salesProductInformation = useProductState();
  const productImageInformation = useProductImageState();
  const productDeliveryInformation = useProductDeliveryState();
  const productOptionInformation = useProductOptionState();
  const productDetailInformation = useProductDetailInformationState();
  const productTagInformation = useProductTagState();
  const productPaymentAdditionalInformation =
    useProductPaymentAdditionalInformationState();
  const [isOpenSubmitModal, setIsOpenSubmitModal] = useState(false);
  const [isOpenLoadModal, setIsOpenLoadModal] = useState(false);
  const [isAmount, setIsAmount] = useState('N');
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  const handleClickSave = () => {
    setIsOpenSubmitModal(true);
  };
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Flex justify="space-between">
            <Title size={3} style={{ marginBottom: 10 }}>
              {defaultData && defaultData?.product_id
                ? '상품 수정'
                : '상품 등록'}
            </Title>
            {defaultData?.product_id ? null : (
              <Button
                size="middle"
                type="primary"
                onClick={() => {
                  setIsOpenLoadModal(true);
                }}
              >
                상품 불러오기
              </Button>
            )}
          </Flex>
          {/* 판매정보 */}
          <SalesInformation
            defaultData={defaultData}
            checkAmount={setIsAmount}
          />
          {/* 판매정보 끝 */}
          {/* 이미지 정보 */}
          <ProductImageInformation defaultData={defaultData} />
          {/* 이미지 정보 끝 */}
          {/* 옵션정보 */}
          {isAmount === 'AMOUNT' ? null : (
            <ProductOptionInformation defaultData={defaultData} />
          )}
          {/* 옵션정보 끝 */}
          {/* 상세정보 설정 */}
          <ProductDetailInformation defaultData={defaultData} editMode />
          {/* 상세정보 설정 끝 */}
          {/* 부가 정보 */}
          <ProductPaymentAdditionalInformation
            defaultData={defaultData}
            editMode
          />
          {/*  부가 정보 끝 */}
          {/* 배송정보 */}
          {isAmount === 'AMOUNT' ? null : (
            <ProductDeliveryInformation defaultData={defaultData} />
          )}
          {/* 배송정보 끝 */}
          {/* 프로모션 설정 */}
          {/* <ProductPromotionInformation /> */}
          {/* 프로모션 설정 끝 */}
          {/* 태그 설정 */}
          <ProductHashtagInformation defaultData={defaultData} />
          {/* 태그 설정 끝 */}
        </Col>

        {/* === 저장버튼 === */}
        <Col x={24} style={{ padding: '30px 0' }}>
          <div
            className="boxShadow"
            style={{
              position: 'fixed',
              bottom: 0,
              right: 0,
              padding: 10,
              width: 'calc(100% - 250px)',
              textAlign: 'right',
              background: '#fff',
              boxShadow: '0 -1px 10px -1px rgba(0,0,0,0.05)',
              borderTop: '1px solid #efefef',
              // display: 'flex',
              // justifyContent: 'space-between',
            }}
          >
            <Button size="default" type="primary" onClick={handleClickSave}>
              <DiffOutlined />{' '}
              {defaultData && defaultData?.product_id ? '수정하기' : '등록하기'}
            </Button>
          </div>
        </Col>
      </Row>

      {/* === === */}
      <ModalLayout
        type={'modal'}
        open={isOpenSubmitModal}
        onCancel={() => setIsOpenSubmitModal(false)}
        centered
        closable
        title={
          defaultData && defaultData?.product_id
            ? '상품을 수정 하시겠습니까?'
            : '상품 등록을 하시겠습니까?'
        }
        width={300}
        footer={
          <Content maxWidth={'100%'} padding={0}>
            <Row>
              <Col x={24}>
                <Button onClick={() => setIsOpenSubmitModal(false)}>
                  취소
                </Button>
                &nbsp;
                <Button
                  type="primary"
                  onClick={() => {
                    if (onSubmit) {
                      let productId = null;

                      if (defaultData && defaultData.product_id) {
                        productId = defaultData.product_id;
                      }

                      onSubmit(
                        productId,
                        salesProductInformation,
                        productImageInformation,
                        productDeliveryInformation,
                        productOptionInformation,
                        productDetailInformation,
                        productTagInformation,
                        productPaymentAdditionalInformation
                      );

                      setIsOpenSubmitModal(false);
                    }
                  }}
                >
                  {defaultData && defaultData.product_id ? '수정' : '등록'}
                </Button>
              </Col>
            </Row>
          </Content>
        }
      />

      {/* 불러오기 모달 */}
      <ModalLayout
        type={'modal'}
        open={isOpenLoadModal}
        onCancel={() => setIsOpenLoadModal(false)}
        centered
        width={900}
        title={'상품 목록'}
        footer={
          <ProductLoadModal
            onDefaultData={onDefaultData}
            onIsOpenLoadModal={setIsOpenLoadModal}
          />
        }
      />
    </Content>
  );
};

export default ProductRegisterPresenter;
